import { useNavigate } from "react-router-dom";
import KroBackButton from "features/components/buttons/kroBackButton";
import useGetArticles from "features/landing/presentation/hooks/useGetArticles";
import FundraiserBlogGrid from "./fundraiserBlogGrid";
import FundraiserBlogGridShimmer from "../components/fundraiserBlog/fundraiserBlogGridShimmer";
import { toast } from "react-toastify";

const FundraiserBlog = () => {
  const navigate = useNavigate();
  const { data, isLoading, error, refetch } = useGetArticles();
  const filteredArticles = data?.pages.flatMap((page) => page.data.filter((article) => article.tags?.some((tag) => tag.name === "Fundraiser" || tag.name === "General")));

  if (error) {
    toast.error(
      ({ closeToast }) => (
        <div className="flex items-center justify-between gap-2">
          <span>{error?.message ?? ""}</span>
          <span
            onClick={() => {
              refetch();
              closeToast();
            }}
            className="text-sm cursor-pointer text-black underline hover:text-gray-700"
          >
            Reload
          </span>
        </div>
      ),
      {
        autoClose: false,
        closeOnClick: false,
      },
    );
  }

  return <div className="mx-2 mt-[50px] max-w-[870px] lg:mx-auto lg:mt-[64px]">
    <KroBackButton
      classname="lg:flex hidden"
      onclick={() => {
        navigate(-1);
      }}
    />
    <div className="mt-[37px] lg:mt-[40px]">
      <div className="flex flex-col gap-2">
        <p className="font-inter text-[20px] font-semibold leading-[100%] tracking-[-1.5%] text-strong-950 lg:text-[32px] lg:leading-[40px] lg:tracking-[-1.5%]">
          Fundraiser 101
        </p>
        <p className="font-inter text-[16px] font-normal leading-[24px] tracking-[-1.5%] text-neutral-700 lg:text-[20px] lg:leading-[28px] lg:tracking-[0em]">
          We have articles that'll answer every question you possibly have about Giv.
        </p>
      </div>
      {isLoading ? <FundraiserBlogGridShimmer /> : <FundraiserBlogGrid articles={filteredArticles} />}
    </div>
  </div>;
};

export default FundraiserBlog;
